var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { attrs: { id: "brand-animation" } }, [
    _c("h2", { domProps: { innerHTML: _vm._s(_vm.title) } }),
    _vm._v(" "),
    _c("div", { staticClass: "mb-1 mb-lg-2 ml-md-1" }, [
      _c("div", { staticClass: "d-flex" }, [
        _c(
          "ul",
          { staticClass: "advantage-list row p-0" },
          _vm._l(_vm.brandAdvantages, function (advantage, index) {
            return _c(
              "li",
              {
                key: "adv-" + index,
                staticClass: "col-12 pb-1 px-1 pl-md-0 pr-md-4",
              },
              [
                _c("div", { staticClass: "advantage-item p-1 p-md-0" }, [
                  _c("span", {
                    staticClass: "advantage-icon pr-1",
                    class: [advantage.icon],
                    attrs: { "aria-hidden": "true" },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mt-1 mt-md-0 mb-md-2" },
                    [
                      _c("p", {
                        staticClass: "lead mb-0 py-0",
                        domProps: { innerHTML: _vm._s(advantage.title) },
                      }),
                      _vm._v(" "),
                      _c("p", {
                        staticClass: "mb-0 py-0",
                        domProps: { innerHTML: _vm._s(advantage.text) },
                      }),
                      _vm._v(" "),
                      advantage.url
                        ? _c("ob1-liens", {
                            staticClass: "pb-0",
                            attrs: {
                              "is-mini": true,
                              text: advantage.labelUrl,
                              href: advantage.url,
                              "with-arrow": true,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
              ]
            )
          }),
          0
        ),
        _vm._v(" "),
        _c("img", {
          staticClass: "advantages-image d-none d-md-flex",
          attrs: { loading: "lazy", alt: "", src: _vm.image },
        }),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }